// A page's header: where it sits (the pages above it), its name, what kind of thing it is (chips), the details, and
// its actions; and the row of links to the page's sections.
import { esc } from '../core'
import { crumbs, type Crumb } from './crumbs'
import { TYPE_COLORS } from './fmt'

export interface Head {
  /** The pages above this one. */
  trail: Crumb[]
  title: string
  /** Inline HTML ahead of the title (a model's dot). */
  mark?: string
  chips?: string
  /** Details, quieter, in order. */
  facts?: string[]
  actions?: string
  /** Below the details (a dataset's conclusion). */
  after?: string
}

export function pageHead(h: Head): string {
  return '<div class="rp-head">' +
    '<div class="rp-head-top">' + (h.trail.length ? crumbs(h.trail, true) : '<span></span>') + (h.actions ? '<div class="rp-acts">' + h.actions + '</div>' : '') + '</div>' +
    '<h2 class="rp-head-title">' + (h.mark || '') + esc(h.title) + '</h2>' +
    ((h.chips || h.facts?.length) ? '<div class="rp-head-meta">' + (h.chips || '') +
      (h.facts?.length ? '<span class="rp-head-facts">' + h.facts.filter(Boolean).join('<span class="rp-dot">·</span>') + '</span>' : '') + '</div>' : '') +
    (h.after || '') + '</div>'
}

/** A task type's chip, in its colour; a plain chip for anything else. */
export const typeChip = (type: string) =>
  '<span class="rp-chip rp-chip-type" style="--c:' + (TYPE_COLORS[type] ?? '#8a857a') + '"><span class="rp-chip-dot"></span>' + esc(type) + '</span>'
export const chip = (text: string) => '<span class="rp-chip">' + esc(text) + '</span>'

/** Links to the page's sections, under its header; `right`, inline HTML at the row's end (a page's filter). */
export function onThisPage(sections: [id: string, label: string][], right = ''): string {
  return '<nav class="rp-toc" aria-label="On this page">' + sections.map(([id, label]) =>
    '<a href="javascript:void(0)" data-jump="' + esc(id) + '">' + esc(label) + '</a>').join('') +
    (right ? '<span class="rp-toc-right">' + right + '</span>' : '') + '</nav>'
}

export function wireToc(root: HTMLElement): void {
  Array.prototype.forEach.call(root.querySelectorAll('.rp-toc [data-jump]'), (a: HTMLElement) => {
    a.onclick = () => root.querySelector('#' + a.getAttribute('data-jump'))?.scrollIntoView({ behavior: 'smooth', block: 'start' })
  })
}

/** A model's colour dot. */
export const dot = (color: string | undefined) => '<span class="rp-mdot" style="background:' + (color ?? '#9a958b') + '"></span>'
